Ext.ns('mx.plugin');

mx.plugin.TabInitializable = function(config) {
    Ext.apply(this, config || {});
};
Ext.extend(mx.plugin.TabInitializable, Ext.util.Observable, {
    init: function(target) {
        var plugin = this;
        Ext.apply(target, {
            getTabs: function() {
                var thiz = this;

                var result = [];

                var ns = plugin.ns();
                if (!ns) return result;

                for (var name in ns) {
                    if (typeof ns[name] == 'function') {
                        var obj = new ns[name]();
                        result.push(obj);
                        if (obj.preventNavigatingAway) {
                            target.preventNavigatingAway = obj.preventNavigatingAway;
                        }
                    }
                }
                result.sort(function(a, b) {
                    if (a.position > b.position) return 1;
                    if (a.position < b.position) return -1;
                    return 0;
                });

                return result;
            },
        });
    },
});
